<template>
  <div v-if="$can('view', 'Yacht')">
    <v-row
      no-gutters
      justify="center"
    >
      <v-col cols="9">
        <div
          v-for="category in categories"
          :key="category.key"
          class="mb-6"
        >
          <logistics-checklist-category
            :key="'logistics-checklist-'+category.key"
            :yacht="yacht"
            :documents="documents[category.key] || []"
            :category="category"
            @update:yacht="$emit('update:yacht', $event)"
            @deleted="documentDeleted"
          />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Document from '@/models/Document'
import { cloneDeep } from 'lodash'
import LogisticsChecklistCategory from '@/components/business/yachts/LogisticsChecklistCategory.vue'

export default {
  name: 'LogisticsChecklist',
  components: {
    LogisticsChecklistCategory
  },
  props: {
    yacht: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      allDocuments: [],
      files: [],
      categories: []
    }
  },
  computed: {
    documents() {
      const allDocuments = this.allDocuments

      let documents = {}

      for (let document of allDocuments) {
        if (!documents[document.logistics_type]) documents[document.logistics_type] = []

        documents[document.logistics_type].push(document)
      }

      return documents
    }
  },
  created() {
    this.getCategories()

    this.allDocuments = cloneDeep(this.yacht.documents).filter(d => d.type === 'logistics' && !!d.logistics_type)
  },
  methods: {
    async getCategories() {
      this.categories = await Document.api.getLogisticsCategories()
    },
    documentDeleted(id) {
      this.allDocuments.splice(this.allDocuments.findIndex(d => d.id === id), 1)
    }
  }
}
</script>

<style scoped>
.file-input {
  position: absolute;
  top: 100%;
  left: 100%;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 10;
  cursor: pointer;
}
</style>
